/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStratEnablerInfo,
    JsonStratEnablerInfoFromJSON,
    JsonStratEnablerInfoFromJSONTyped,
    JsonStratEnablerInfoToJSON,
} from './JsonStratEnablerInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonStratEnablerInfo
 */
export interface ApiResultOfListOfJsonStratEnablerInfo {
    /**
     * 
     * @type {Array<JsonStratEnablerInfo>}
     * @memberof ApiResultOfListOfJsonStratEnablerInfo
     */
    data?: Array<JsonStratEnablerInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratEnablerInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonStratEnablerInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratEnablerInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratEnablerInfo
     */
    result?: ApiResultOfListOfJsonStratEnablerInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonStratEnablerInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonStratEnablerInfoFromJSON(json: any): ApiResultOfListOfJsonStratEnablerInfo {
    return ApiResultOfListOfJsonStratEnablerInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonStratEnablerInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonStratEnablerInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonStratEnablerInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonStratEnablerInfoToJSON(value?: ApiResultOfListOfJsonStratEnablerInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonStratEnablerInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

